import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, DatePicker, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import moment from 'moment'
const storage = window.localStorage
const { RangePicker } = DatePicker;

@inject('manualOutboundCallStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {manualOutboundCallStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    manualOutboundCallStore.onSearchJobAction({page: 1, size: PAGE_SIZE_DEFAULT, isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser})
    manualOutboundCallStore.onGetGroup({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    })
    manualOutboundCallStore.getAuditUsers()
    manualOutboundCallStore.onGetStatus('ManualSyncStatus')
  }

  handleSearch = () => {
    const {manualOutboundCallStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'marketGroupId': fieldsValue.marketGroupId,
        'logUser': fieldsValue.logUser,
        'startTime': fieldsValue?.logsTime ? moment(fieldsValue?.logsTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        'endTime': fieldsValue?.logsTime ? moment(fieldsValue?.logsTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
        'callStatus': fieldsValue.callStatus,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      manualOutboundCallStore.onSearchJobAction(params)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {manualOutboundCallStore, location, t} = this.props
    const {groupList, auditLogsUserList, statusList} = manualOutboundCallStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={4}>
              <Form.Item name="marketGroupId" label={t(`outboundCall.groupName`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="callStatus" label={t(`outboundCall.callingStatus`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {statusList?.map(item => (<Select.Option key={item.code} value={item.code}>{item.name}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="logUser" label={t(`outboundCall.operator`)}>
                <Select
                  placeholder={t(`general.pleaseSelect`)}
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {
                    auditLogsUserList.length > 0
                      ? auditLogsUserList.map(item => <Select.Option key={item.id} value={item.shortName}>{item.shortName}</Select.Option>)
                      : null
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="logsTime" label={t(`outboundCall.callTime`)}>
                <RangePicker showTime/>
              </Form.Item>
            </Col>
            <Col span={6} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} className="ant-btn-red">{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)